import React from 'react';
import './hinnastoNew.css';

var laskutusData = {
  header: {
    title: "Laskutuskäytännöt",
    subtitle: "Tietoa lukukausimaksujen laskutuksesta ja maksuaikatauluista"
  },
  intro: [
    {
      text: "Lukukausimaksut laskutetaan Järvenpään kaupungilta tulevalla laskulla joko postitse tai sähköisenä verkkolaskuna. Suosittelemme verkkolaskusopimuksen tekemistä. Laskureskontran Järvenpään kaupungilla hoitaa Sarastia. Laskukopion voi pyytää tarvittaessa suoraan",
      link: { text: "Sarastiasta", href: "https://asiakaspalvelu.sarastia.fi/lomakkeet/pyyda-laskukopio/" }
    },
    {
      text: "Syyslukukauden laskut lähetetään syys-lokakuussa ja kevätlukukauden laskut tammi-helmikuussa. Lukukausimaksu laskutetaan kerralla. Laskulle voi pyytää pidennettyä maksuaikaa, katso ohjeet alla. Mikäli maksu viivästyy, eikä lykkäystä ole haettu, lähetetään maksumuistutus 14-21 vuorokauden kuluttua eräpäivästä. Mikäli saatava on ensimmäisen maksumuistutuksen jälkeen edelleen avoinna, asiakkaalle lähetetään perintäkirje. Perintätoimisto Intrum huolehtii maksumuistutusten lähettämisestä ja hoitaa perintätoimet."
    },
    {
      text: "Katso useimmin kysytyt kysymykset",
      link: { text: "täältä.", href: "/faq" }
    }
  ],
  installments: {
    title: "Musiikkiopiston lukukausimaksun maksaminen erissä",
    steps: [
      "Musiikkiopistolta tulee yksi lasku, joka sisältää lukukausimaksun kokonaisuudessaan.",
      "Mikäli haluat pyytää muutosta maksuaikaan, laita viestiä osoitteeseen musiikkiopisto@jarvenpaa.fi. Mainitse viestissä laskutettavan oppilaan nimi.",
      "Saat vastauksena maksuaikaehdotuksen.",
      "Suorita maksujen erät sovitun maksuaikataulun mukaisesti laskusi tiedoilla."
    ],
    note: {
      strong: "Yksittäisistä eristä ei tule laskuja kotiin, joten on tärkeää säilyttää alkuperäinen lasku ja maksaa kaikki erät sen viitetiedoilla.",
      rest: "Kysy tarvittaessa lisätietoja musiikkiopiston toimistosta."
    }
  }
};

function LinkkiKappale(props) {
  var paragraph = props.paragraph;

  if (!paragraph.link) {
    return <p>{paragraph.text}</p>;
  }

  return (
    <p>
      {paragraph.text}
      &nbsp;
      <a href={paragraph.link.href} target="_blank" rel="noreferrer">
        {paragraph.link.text}
      </a>
    </p>
  );
}

function Laskutustiedot() {
  return (
    <div className="hinnasto-stripe-layout">
      <section  className="hero-header hero-header--compact">
        <h1>{laskutusData.header.title}</h1>
        <p>{laskutusData.header.subtitle}</p>

        <div  className="hero-wave">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path
              d="M0,80 C300,10 900,140 1200,50 L1200,120 L0,120 Z"
              fill="#b515d1"
              opacity="0.10"
            />
            <path
              d="M0,64 C300,120 900,0 1200,64 L1200,120 L0,120 Z"
              fill="#e8eaec"
            />
          </svg>
        </div>
      </section>

      <div className="laskutus-container">
        <main className="laskutus-content">

          <section className="content-section">
            <div className="section-description">
              {laskutusData.intro.map(function (paragraph, i) {
                return <LinkkiKappale key={i} paragraph={paragraph} />;
              })}
            </div>
          </section>

          <section className="content-section">
            <h2>{laskutusData.installments.title}</h2>
            <ol className="steps-list">
              {laskutusData.installments.steps.map(function (step, i) {
                return <li key={i}>{step}</li>;
              })}
            </ol>

            <div className="important-note">
              <p>
                <strong>{laskutusData.installments.note.strong}</strong>
                &nbsp;
                {laskutusData.installments.note.rest}
              </p>
            </div>
          </section>

        </main>
      </div>
    </div>
  );
}

export default Laskutustiedot;